// src/reducers/userpinReducer
import ActionType from 'actions/ActionType'
import { omit } from 'lodash'

const userpinReducer = (state = {}, action) => {
  switch (action.type) {
    case ActionType.Data.LIST_SUCCESS:
      if (action.entityType === 'userpin') {
        return action.payload.reduce(
          (acc, userpin) => {
            if (!acc[userpin.secondary_id]) {
              acc[userpin.secondary_id] = {}
            }
            acc[userpin.secondary_id][userpin.pinned_entity_id] = userpin
            return acc
          },
          { ...state },
        )
      }
      return state
    case ActionType.Data.CREATE_SUCCESS:
      if (
        action.entityType === 'userpin' &&
        action.payload?.secondary_id &&
        action.payload?.pinned_entity_id
      ) {
        return {
          ...state,
          [action.payload.secondary_id]: {
            ...(state?.[action.payload.secondary_id] || {}),
            [action.payload.pinned_entity_id]: action.payload,
          },
        }
      }
      return state
    case ActionType.Data.DELETE_SUCCESS:
      if (
        action.entityType === 'userpin' &&
        action.entity?.secondary_id &&
        action.entity?.pinned_entity_id
      ) {
        // console.log('hits userpin if delete success')
        // console.log('action.entity.secondary_id: ', action.entity.secondary_id)
        // console.log(
        //   'action.entity.pinned_entity_id: ',
        //   action.entity.pinned_entity_id,
        // )
        // console.log(
        //   'omitted state: ',
        //   omit(
        //     state[action.entity.secondary_id],
        //     action.entity.pinned_entity_id,
        //   ),
        // )

        return {
          ...state,
          [action.entity.secondary_id]: omit(
            state[action.entity.secondary_id],
            action.entity.pinned_entity_id,
          ),
        }
      }
      return state
    default:
      return state
  }
}

export default userpinReducer
